















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Users from "./user_player.vue";

@Component({
  components: {
    Users
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop() type!: string;
}
